import GeneratorView from "../../components/GeneratorView";
import GeneratorOptions from "./GeneratorOptions";
import generator from "generate-password";

// TODO: use https://www.npmjs.com/package/check-password-strength for strength

const generate = ({ length, count, casing, symbols, numbers, strict }) => {
  try {
    return !length
      ? ["Please enter a positive length"]
      : generator.generateMultiple(count, {
          length,
          lowercase: casing === "mixed" || casing === "lowercase",
          uppercase: casing === "mixed" || casing === "uppercase",
          symbols,
          numbers,
          strict,
        });
  } catch (err) {
    return err.toString();
  }
};

const Index = ({ strings, toolStrings }) => (
  <GeneratorView
    strings={strings}
    toolStrings={toolStrings}
    onGenerate={generate}
    optionsView={GeneratorOptions}
    options={{
      length: 15,
      count: 20,
      casing: "mixed",
      numbers: true,
      symbols: true,
      strict: true,
    }}
  />
);

export default Index;
